import { ESLint } from "eslint";

export default parseInt(ESLint.version, 10);
